import { Link } from 'react-router-dom'

export function Footer() {
  return (
    <footer className="bg-white border-t border-gray-200 pb-16 md:pb-0">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-2">
            <span className="text-lg font-bold text-gradient">VaultLynk</span>
            <span className="text-sm text-gray-500">
              © {new Date().getFullYear()} All rights reserved.
            </span>
          </div>

          <nav className="flex items-center gap-6" aria-label="Footer navigation">
            <Link
              to="/pricing"
              className="text-sm text-gray-600 hover:text-gray-900"
            >
              Pricing
            </Link>
            <Link
              to="/privacy"
              className="text-sm text-gray-600 hover:text-gray-900"
            >
              Privacy
            </Link>
            <Link
              to="/terms"
              className="text-sm text-gray-600 hover:text-gray-900"
            >
              Terms
            </Link>
            <Link
              to="/contact"
              className="text-sm text-gray-600 hover:text-gray-900"
            >
              Contact
            </Link>
          </nav>
        </div>
      </div>
    </footer>
  )
}
